module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M29.134 2.18l1.732 1-20 34.64-1.732-1z\" fill-rule=\"evenodd\"></path></svg>"